import { render } from "./ProductWiseSgcConsumption.vue?vue&type=template&id=9ddc311c&scoped=true&ts=true"
import script from "./ProductWiseSgcConsumption.vue?vue&type=script&lang=ts"
export * from "./ProductWiseSgcConsumption.vue?vue&type=script&lang=ts"

import "./ProductWiseSgcConsumption.vue?vue&type=style&index=0&id=9ddc311c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ddc311c"]])

export default __exports__